export default {
  meta: {
    title: '踩点宝-对比'
  }
};
